export function toSlug(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFD')                 // décompose les accents (é → e + ́)
    .replace(/[\u0300-\u036f]/g, '')  // supprime les diacritiques
    .replace(/\s+/g, '-')            // espaces → tirets
    .replace(/[^a-z0-9-]/g, '')      // supprime les caractères spéciaux
    .replace(/-+/g, '-')             // tirets multiples → un seul
    .trim();
}